// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/4ea837d629607b2bd8e8.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"c44b0351edd842fbfe20","159":"0d8baa355c1932357ae6","160":"078eab575e4b63e30602"}[chunkId] + ".chunk.js";
};